
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore  } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyD4iyC_-Jz3p9jH6aQuNLmNHHBbcL716os",
  authDomain: "chat-5fb59.firebaseapp.com",
  projectId: "chat-5fb59",
  storageBucket: "chat-5fb59.appspot.com",
  messagingSenderId: "533239960527",
  appId: "1:533239960527:web:38525ee4ddc320021178ba"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db =  getFirestore();